import styled from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const StyledHeader = styled.header`
  width: 100%;
  height: 100vh;
  background: radial-gradient(
    circle at center,
    ${theme.colors.accent.primaryLight},
    ${theme.colors.accent.primary}
  );
`

export const Button = styled.a`
  ${styleReset}
  position: relative;
  display: block;
  text-decoration: none;
  font-size: 1.6rem;
  color: ${theme.colors.text};
  width: max-content;
  margin: 0 auto;
  padding: 0.6em 1.2em;
  border-radius: 2em;
  background-color: white;

  ${mq.medium} {
    font-size: 2.1rem;
  }
`
